// @core/api/endpoints/analytics/list_report_schedules.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListReportSchedulesResponse,
} from '../../../types/analytics';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/analytics';

/**
 * List report schedules
 * Returns all report schedules configured for the tenant.
 */
export async function ListReportSchedules(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListReportSchedulesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/report-schedules`;
  const requestOptions = options;
  return client.get<ListReportSchedulesResponse>(requestPath, { ...requestOptions, params });
}
